<script>
    import { GET, POST } from "../../components/communication.js";
    import { authToken, sessionStorageSet, sessionStorageRemove, flashErrorMessage, flashSuccessMessage }
        from "../../components/stores.js";
    import { navigate } from "svelte-routing";
    import {onMount} from "svelte";

    let login = { username: "", password: "" };

    onMount(async function () {
        sessionStorageRemove("authToken");
        authToken.set('');
        sessionStorage.clear();
        window.location.href='/';
    });
</script>
<div class="page">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="page-title text-center">
                    <h4>Kirjauduit ulos</h4>
                </div>
            </div>
        </div>
    </div>
</div>
